export default __webpack_public_path__ + "static/media/farwest_vs_perky.dd75a878.jpg";